import Cookies from 'js-cookie';
import Commercial from './commercial';

class Cmp {

	constructor(options) {
		let defaults = {
			prebid: true,
			google: true,
			png: true,
			tempo: true,
			exitbee: true,
			butterfly: true,
			preroll: true,
			agora: true,
			groupm: true,
			unilever: true,
			nielsen: true,
			smartAdserver: true
		};
		this.params = Object.assign({}, defaults, options || {});
		this.start();
	}

	start() {

		if (typeof __nocmp !== 'undefined') {
			this.loadGoogleVendor(false);
			return;
		}

		// If CMP is not loaded check again after 1 second
		if (typeof __tcfapi === 'undefined') {

			window.setTimeout(() => {
				this.start();
			}, 1000);

			return;
		}

		var self = this;

		// Check consent
		__tcfapi('addEventListener', 2, function (tcData, success) {

			if (!success) {
				return;
			}

			if (tcData.eventStatus === 'useractioncomplete' || tcData.eventStatus === 'tcloaded') {

				var consents = tcData.purpose.consents;
				var legitimateInterests = tcData.purpose.legitimateInterests;

                gtag('consent', 'update', {
                    'ad_storage': consents[1] ? 'granted' : 'denied',
                    'ad_user_data': (consents[1] && consents[7]) ? 'granted' : 'denied',
                    'ad_personalization': (consents[3] && consents[4]) ? 'granted' : 'denied',
                    'analytics_storage': (consents[7] && consents[8] && consents[9] &&
                        consents[10]) ? 'granted' : 'denied',
                    'functionality_storage': consents[2] ? 'granted' : 'denied',
                    'personalization_storage': (consents[3] && consents[4]) ? 'granted' : 'denied',
                    'security_storage': consents[7] ? 'granted' : 'denied',
                });

                if (
                    !consents[1] ||
                    !(consents[7] && consents[8] && consents[9] && consents[10])
                ) {
                    gtag('set', 'url_passthrough', true);
                }

				/*
				1: Store and/or access information on a device
				2: Select basic ads
				3: Create a personalised ads profile
				4: Select personalised ads
				5: Create a personalised content profile
				6: Select personalised content
				7: Measure ad performance
				8: Measure content performance
				9: Apply market research to generate audience insights
				10: Develop and improve products
				*/

				var can_1 = consents['1'] ? 1 : 0;
				var can_2 = consents['2'] ? 1 : 0;
				var can_3 = consents['3'] ? 1 : 0;
				var can_4 = consents['4'] ? 1 : 0;
				var can_5 = consents['5'] ? 1 : 0;
				var can_6 = consents['6'] ? 1 : 0;
				var can_7 = consents['7'] ? 1 : 0;
				var can_8 = consents['8'] ? 1 : 0;
				var can_9 = consents['9'] ? 1 : 0;
				var can_10 = consents['10'] ? 1 : 0;

				var may_1 = legitimateInterests['1'] ? 1 : 0;
				var may_2 = legitimateInterests['2'] ? 1 : 0;
				var may_3 = legitimateInterests['3'] ? 1 : 0;
				var may_4 = legitimateInterests['4'] ? 1 : 0;
				var may_5 = legitimateInterests['5'] ? 1 : 0;
				var may_6 = legitimateInterests['6'] ? 1 : 0;
				var may_7 = legitimateInterests['7'] ? 1 : 0;
				var may_8 = legitimateInterests['8'] ? 1 : 0;
				var may_9 = legitimateInterests['9'] ? 1 : 0;
				var may_10 = legitimateInterests['10'] ? 1 : 0;

				// Store and/or access information on a device (Purpose 1)
				if (!can_1) {
					self.loadGoogleVendor(false);
					return;
				}

				// Google Advertising Products
				// Action = create a new commercial.js module
				if (self.params.google == true && tcData.vendor.consents['755'] && tcData.vendor.legitimateInterests['755']) {
					if ((can_2 || may_2) && (can_7 || may_7) && (can_9 || may_9) && (can_10 || may_10)) {
						let personalized = can_3 && can_4;
						self.loadGoogleVendor(personalized);
					}
				}

				window.__tcfapi('getNonIABVendorConsents', 2, function (nonIabConsent, nonIabSuccess) {
					if (nonIabSuccess && nonIabConsent.nonIabVendorConsents) {
                        
					}
				});

			}
		});
	}

	loadGoogleVendor(personalized) {

		new Commercial({
			loadScripts: true,
			personalized: personalized,
			prebid: this.params.prebid,
			preroll: this.params.preroll
		});
	}

	repropmpt() {
		Cookies.remove('euconsent-v2', {
			path: '/',
			domain: '.' + location.host
		});

		__tcfapi('displayConsentUi', 2, function () { });
	}
}

export {
	Cmp as
		default
};
